import { FormControl, AbstractControl } from "@angular/forms";

export class CustomValidators {

    public static passwordsMatch(AC: AbstractControl) {
        let password = AC.get('password').value; // to get value in input tag
        let confirmPassword = AC.get('confirmPassword').value; // to get value in input tag
        if (password != confirmPassword) {
            console.log('CustomValidators > passwordsMatch > passwordsMismatch', password, confirmPassword);
            AC.get('confirmPassword').setErrors({ passwordsMismatch: true })
        } else {
            console.log('CustomValidators > passwordsMatch > passwordsMatch', password, confirmPassword);
            return null
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/main/helpers/custom-validators.helper.ts